import Streaming from '../streaming/streaming';
import {initTopBottom} from "../modulos/topbottom/topbottom";
import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";
import importantQuotes from "../modulos/importantQuotes/importantQuotes";
import instrumentBox from "../modulos/instrumentBox/instrumentBox";
import {laBolsaHoyTickerPremiumNews} from "../modulos/laBolsaHoy/laBolsaHoy";

export const loadLBHPage = () => {
    console.log('Loading LBH Page');

    //Inicializa los importantQuotes
    importantQuotes(Streaming);

    //Inicializa instrumentBox
    instrumentBox(Streaming);

    //Inicializa los módulos de top/flops
    initTopBottom(Streaming);

    //Módulo de análisis más vistos
    analisisMasVistos();

    //Página completa LBH ofuscando las noticias premium
    (function(){
        laBolsaHoyTickerPremiumNews().then(() => {
            console.log('Bolsa hoy premium OK');
        });
    })();

}

